import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "title"]

  connect() {
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const source = document.getElementById(button.dataset.payloadModalSourceId)
    const rawContent = source ? source.textContent.trim() : ""
    const title = button.dataset.payloadModalTitle || "Payload"

    let formattedContent
    try {
      formattedContent = JSON.stringify(JSON.parse(rawContent), null, 2)
    } catch (_error) {
      formattedContent = rawContent
    }

    if (this.hasTitleTarget) this.titleTarget.textContent = title
    if (this.hasContentTarget) this.contentTarget.textContent = formattedContent
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.handleKeyDown)
  }

  close(event) {
    if (event) event.preventDefault()

    if (this.hasModalTarget) this.modalTarget.classList.add("hidden")
    if (this.hasContentTarget) this.contentTarget.textContent = ""
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.handleKeyDown)
  }

  handleKeyDown(event) {
    if (event.key === "Escape") this.close()
  }
}
